module.exports = __webpack_public_path__ + "img/logo.3c12a444.png";